import { Injectable } from '@angular/core';
import { OdooMasterService } from '@app-core/odoo/odoo-master.service';
import { Profile, ProfileCompany, ProfileCSituacionFiscal } from 'app/core/profile/profile.types';
import { Observable, of, switchMap, ReplaySubject } from 'rxjs';
import { ProfileMenus } from 'app/core/profile/profile.types';

@Injectable({
    providedIn: 'root',
})
export class ProfileService extends OdooMasterService {
    private _menus: ReplaySubject<ProfileMenus> = new ReplaySubject<ProfileMenus>(1);
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * getDetails
     */
    getDetails(): Observable<any> {
        return this.sendRequest('/api/web/user/get/details', {}, 'get').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    /**
     * updateAccountProfile
     *
     * @param params
     */
    updateAccountProfile(params: Profile): Observable<any> {
        return this.sendRequest(
            '/api/web/user/account/update',
            params,
            'patch'
        ).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    /**
     * updateAccountProfile
     *
     * @param params
     */
    updateCompanyProfile(params: ProfileCompany): Observable<any> {
        return this.sendRequest(
            '/api/web/user/company/update',
            params,
            'patch'
        ).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    /**
     * getCompanyDetails
     */
    getCompanyDetails(address_id: number): Observable<any> {
        return this.sendRequest(
            `/api/web/user/get/company/${address_id}`,
            {},
            'get'
        ).pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    /**
     * updateFiscalSituation
     *
     * @param params
     */
    updateCompanyFiscal(params: ProfileCSituacionFiscal): Observable<any> {
        return this.sendRequest('/api/web/user/company/csituacionf', params, 'patch').pipe(
            switchMap((response: any) => {
                return of(response);
            })
        );
    }

    getProfileMenus(): Observable<any> {
        return this.sendRequest(`/api/web/user/get/menu`, {}, 'get').pipe(
            switchMap((response: any) => {
                this.menu = response?.data;
                return of(response);
            })
        );
    }


    set menu(value: ProfileMenus) {
		// Actualiza el observable
		this._menus.next(value);
	}

	get subordinates$(): Observable<ProfileMenus> {
		return this._menus.asObservable();
	}

	/**
	 * Get the current signed-in user data
	 */
	get(): Observable<ProfileMenus> {
		let profileMenus = this.menu ?? {};
		this._menus.next(profileMenus);
		return of(profileMenus);
	}
}